import { useSiteBrand } from "@/data/siteBrand";
import { HOME_HERO_URL, handleHomeHeroClick } from "@/utils/homeNavigation";
import { getSiteLocale } from "@/i18n/locale";
import { uiText } from "@/i18n/translations";

type IdentityChromeProps = {
  menuOpen: boolean;
  onToggleMenu: () => void;
};

export function IdentityChrome({ menuOpen, onToggleMenu }: IdentityChromeProps) {
  const brand = useSiteBrand();
  const locale = getSiteLocale();

  return (
    <div className="identity-chrome">
      <a
        className="identity-chrome-logo"
        href={HOME_HERO_URL}
        aria-label={`${brand.brand_name} ${locale === "el" ? "αρχική" : "home"}`}
        onClick={handleHomeHeroClick}
      >
        <img
          className="identity-chrome-logo-fallback"
          src={brand.logo_url}
          alt=""
          aria-hidden="true"
        />
        <span
          className="identity-chrome-logo-layer identity-chrome-logo-layer--dark"
          aria-hidden="true"
        />
        <span
          className="identity-chrome-logo-layer identity-chrome-logo-layer--light"
          aria-hidden="true"
        />
        <span
          className="identity-chrome-logo-layer identity-chrome-logo-layer--contrast"
          aria-hidden="true"
        />
      </a>

      <button
        type="button"
        className="identity-chrome-menu"
        data-magnetic
        aria-label={uiText(menuOpen ? "Close menu" : "Open menu", locale)}
        aria-expanded={menuOpen}
        aria-controls="siteMenuOverlay"
        onClick={onToggleMenu}
      >
        <span className="identity-chrome-menu-face identity-chrome-menu-face--dark">
          {brand.menu_label}
        </span>
        <span
          className="identity-chrome-menu-face identity-chrome-menu-face--light"
          aria-hidden="true"
        >
          {brand.menu_label}
        </span>
      </button>
    </div>
  );
}
